"use strict";
const { object, string, number, mixed, array, } = require('../utils/modifiedYup');
const displayComponentPropertySchema = object().shape({
    name: string().required(),
    label: string(),
    control: string().required(),
    value: mixed(),
});
const formComponentVariablePropertySchema = object().shape({
    name: string().required(),
    value: string().required(),
    valueType: string().required(),
});
exports.displayComponentSchema = object().shape({
    id: number().required(),
    type: string().required(),
    label: string().required(),
    properties: array().of(displayComponentPropertySchema).required(),
});
exports.formComponentSchema = object().shape({
    id: number().required(),
    type: string().required(),
    label: string().required(),
    properties: array()
        .oneOfSchemas([
        displayComponentPropertySchema,
        formComponentVariablePropertySchema,
    ])
        .required(),
    componentType: string().oneOf(['form']).required(),
});
//# sourceMappingURL=componentSchema.js.map